import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "file-upload__content"
}
const _hoisted_2 = { class: "file-upload__content__top" }
const _hoisted_3 = {
  key: 0,
  class: "file-upload__title"
}
const _hoisted_4 = {
  key: 1,
  class: "file-upload__description"
}
const _hoisted_5 = {
  key: 1,
  class: "file-upload__file"
}
const _hoisted_6 = ["src"]

import { PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AiFileUpload',
  props: {
  title: {
    type: String as PropType<string>,
    required: false,
  },
  description: {
    type: String as PropType<string>,
    required: false,
  },
  modelValue: {
    type: File as PropType<File>,
    required: false,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emits = __emit;

const fileInput = ref<HTMLInputElement | null>(null);
const previewUrl = ref<string>('');

const openFileDialog = (): void => {
  fileInput.value?.click();
};

const handleFileSelect = (event: Event): void => {
  const { files } = event.target as HTMLInputElement;
  if (files && files.length > 0) {
    emits('update:modelValue', files[0]);
  }
};

const handleFileDrop = (event: DragEvent): void => {
  event.preventDefault();
  const files = event.dataTransfer?.files;
  if (files && files.length > 0) {
    emits('update:modelValue', files[0]);
  }
};

const previewImage = (file: File): void => {
  if (file.type.startsWith('image/')) {
    const reader = new FileReader();
    reader.onload = () => {
      previewUrl.value = reader.result as string;
    };
    reader.readAsDataURL(file);
  }
};

__expose({
  openFileDialog,
});

watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal) {
      previewImage(newVal);
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "file-upload",
    onClick: openFileDialog,
    onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
    onDrop: handleFileDrop,
    onKeyup: openFileDialog
  }, [
    (!props.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "top")
          ]),
          (props.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(props.title), 1))
            : _createCommentVNode("", true),
          (props.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(props.description), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (previewUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: previewUrl.value,
                alt: ""
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true)
        ])),
    _createElementVNode("input", {
      ref_key: "fileInput",
      ref: fileInput,
      type: "file",
      style: {"display":"none"},
      onChange: handleFileSelect
    }, null, 544)
  ], 32))
}
}

})